import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { SpuCoinsDetailQuery, SpuCoinsDetailVo, SpuCoinCalculateQuery, SpuCoinCalculateVo } from './type';

/**
 * spu展示页面
 金币业务详情页查询(该接口适用于金币业务下平台/区域/服务器只有一个比如是平台，且这个平台只有1个值的情况)
  GET /product/urlMapping/game-service/getCoinsSkuDetailWithSpu
  接口ID：257336690
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-257336690
 */
export const getSpuCoinsDetail = (params: SpuCoinsDetailQuery): AxiosPromise<SpuCoinsDetailVo> => {
  return request({
    url: '/product/urlMapping/game-service/getCoinsSkuDetailWithSpu',
    method: 'get',
    params
  });
};

/**
 * 计算价格
  GET /product/urlMapping/game-service/calculatePrice
  接口ID：265253975
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-265253975
 */
export const getSpuCoinsCalculatePrice = (params: SpuCoinCalculateQuery): AxiosPromise<SpuCoinCalculateVo> => {
  return request({
    url: '/product/urlMapping/game-service/calculatePrice',
    method: 'get',
    params
  });
};
